import { CancelTokenSource } from 'axios'
import Agent from '../api/Agent'

class RefDataService {
  getCustomerTypes() {
    return Agent.RefData.getCustomerTypes()
  }
  getGender() {
    return Agent.RefData.getGenders()
  }
  getIndustries() {
    return Agent.RefData.getIndustries()
  }
  getSubIndustries() {
    return Agent.RefData.getSubIndustries()
  }
  getSubIndustry(id: string, source?: CancelTokenSource) {
    return Agent.RefData.getSubIndustry(id, source)
  }
  getTitles() {
    return Agent.RefData.getTitles()
  }
  getRegions() {
    return Agent.RefData.getRegions()
  }
  getGenders() {
    return Agent.RefData.getGenders()
  }
  getAwards() {
    return Agent.RefData.getAwards()
  }
  getBusinessDescriptions() {
    return Agent.RefData.getBusinessDescriptions()
  }
  getYesNoUnsure() {
    return Agent.RefData.getYesNoUnsure()
  }
  getIssues(languageId: number) {
    return Agent.RefData.getIssues(languageId)
  }
  getSubIssues(index: number) {
    return Agent.RefData.getSubIssues(index)
  }
  getEmployeeAttributes(languageId: number) {
    return Agent.RefData.getEmploymentAttributes(languageId)
  }
  getReportIndustries(languageId: number) {
    return Agent.RefData.getReportIndustries(languageId)
  }
  getReportSubIndustries(index: number) {
    return Agent.RefData.getReportSubIndustries(index)
  }
  getEmploymentTypes() {
    return Agent.RefData.getEmploymentTypes()
  }
  getApprenticeTrainees() {
    return Agent.RefData.getApprenticeTrainees()
  }
  getEmployeeDescriptions() {
    return Agent.RefData.getEmployeeDescriptions()
  }
  getVisaTypes() {
    return Agent.RefData.getVisaTypes()
  }
  getOfficeLocations() {
    return Agent.RefData.getOfficeLocations()
  }
  getHowDidYouFind() {
    return Agent.RefData.getHowDidYouFind()
  }
  getLanguages() {
    return Agent.RefData.getLanguages()
  }
  getRequestForAssistanceInfoCategories() {
    return Agent.RefData.getRequestForAssistanceInfoCategories()
  }
  getRequestForAssistanceInfoSubCategories() {
    return Agent.RefData.getRequestForAssistanceInfoSubCategories()
  }
  getGenuineContractEmployees() {
    return Agent.RefData.getGenuineContractEmployees()
  }
  getCountries() {
    return Agent.RefData.getCountries()
  }
  getCountryCodes() {
    return Agent.RefData.getCountryCodes()
  }
  getOccupations(term: string) {
    return Agent.RefData.getOccupations(term)
  }
  getReasonNotSpokenToEmployers() {
    return Agent.RefData.getReasonNotSpokenToEmployers()
  }
  getEvidences() {
    return Agent.RefData.getEvidences()
  }
}

export default new RefDataService()
